import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Box } from "@gemini/core";
import { AdContainer } from "./AdContainer";
import { AdSlotIds } from "@/shared/types";
import { MasonryContainer, subGridColumn, } from "../../Gallery/components/Masonry/ui";
import { useShowAds } from "../hooks/useShowAds";
import { useFarbwelt } from "@/hooks";
import { useEffect } from "react";
import { useAdsContext } from "../context";
import { useIsPubstackEnabled } from "../utils/utils";
import { getFeaturesEnabled } from "@/utils";
export const MasonryAd = () => {
    const { showSection } = useShowAds();
    const { isFarbweltActive } = useFarbwelt();
    const { setLoadedSlot } = useAdsContext();
    const isPubstackEnabled = useIsPubstackEnabled();
    const { showOptionalAdsWithFarbwelt } = getFeaturesEnabled();
    const shouldShowAd = !isFarbweltActive || showOptionalAdsWithFarbwelt;
    useEffect(() => {
        if (isPubstackEnabled && shouldShowAd) {
            setLoadedSlot(AdSlotIds.AD_MASONRY, "loading");
            // eslint-disable-next-line no-restricted-globals
            window.dispatchEvent(new CustomEvent("admSPAReload"));
        }
    }, [isPubstackEnabled, shouldShowAd, setLoadedSlot]);
    return (_jsx(_Fragment, { children: shouldShowAd && (_jsx(MasonryContainer, { children: _jsx(Box, { id: `gallery-ad-container`, gridColumn: subGridColumn("full", 0), unsafe_style: { aspectRatio: "3/2" }, width: "100%", display: showSection([AdSlotIds.AD_MASONRY]) ? "flex" : "none", justifyContent: "center", alignItems: "center", position: "relative", paddingTop: "spacing.48", children: _jsx(AdContainer, { adSlotId: AdSlotIds.AD_MASONRY, width: "100%", height: "100%", display: "flex", showLabel: true, dynamicSlot: true }) }) })) }));
};
